<div class="menu">
    <div class="list-block extended" [class.active]="!reduced">
        <div class="header-block">
            <app-user-badge [state]="'extended'"/>
            <a
                routerLink="/"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                matTooltip="Главная"
                class="menu__link"
            >
                <div class="menu__icon" [style]="{
                            '--bg-img': 'url(/assets/icons/default/home-black.svg)',
                            '--bg-img-active': 'url(/assets/icons/active/home-white.svg)',
                            }"></div>
                <span class="menu__name">Главная</span>
            </a>
            <app-accordiion [defaultOpen]="true">
                <div class="title">Испытания</div>
                <div class="details">
                    @for (item of menu.test; track item.name) {
                        @if (guardMenu(item.right)|async) {
                            <a [routerLink]="item.href"
                               [matTooltip]="item.name"
                               class="menu__link"
                               [class.active]="isActive('/'+item.href)"
                            >
                                <div class="menu__icon" [style]="{
                            '--bg-img': 'url('+item.icon+')',
                            '--bg-img-active': 'url('+item.active+')',
                            }"></div>
                                <span class="menu__name">{{ item.name }}</span>
                            </a>
                        }
                    }
                </div>
            </app-accordiion>
            <app-accordiion [defaultOpen]="true">
                <div class="title">Справочники</div>
                <div class="details">
                    @for (item of menu.guides; track item.name) {
                        @if (guardMenu(item.right)|async) {
                            <a
                                [routerLink]="item.href"
                                class="menu__link"
                                [class.active]="isActive('/'+item.href)"
                            >
                                <div class="menu__icon" [style]="{
                            '--bg-img': 'url('+item.icon+')',
                            '--bg-img-active': 'url('+item.active+')',
                            }"></div>
                                <span class="menu__name">{{ item.name }}</span>
                            </a>
                        }
                    }
                </div>
            </app-accordiion>
            <app-accordiion [defaultOpen]="true">
                <div class="title">Аналитика</div>
                <div class="details">
                    @for (item of menu.analytics; track item.name) {
                        @if (guardMenu(item.right)|async) {
                            <a
                                [routerLink]="item.href"
                                class="menu__link"
                                [class.active]="isActive('/'+item.href)"
                            >
                                <div class="menu__icon" [style]="{
                            '--bg-img': 'url('+item.icon+')',
                            '--bg-img-active': 'url('+item.active+')',
                            }"></div>
                                <span class="menu__name">{{ item.name }}</span>
                            </a>
                        }
                    }
                </div>
            </app-accordiion>
            <app-accordiion [defaultOpen]="true">
                <div class="title">Администрирование</div>
                <div class="details">
                    @for (item of menu.admin; track item.name) {
                        @if (guardMenu(item.right)|async) {
                            <a
                                [routerLink]="item.href"
                                class="menu__link"
                                [class.active]="isActive('/'+item.href)"
                            >
                                <div class="menu__icon" [style]="{
                            '--bg-img': 'url('+item.icon+')',
                            '--bg-img-active': 'url('+item.active+')',
                            }"></div>
                                <span class="menu__name">{{ item.name }}</span>
                            </a>
                        }
                    }
                </div>
            </app-accordiion>
        </div>
        <div class="footer-block">
<!--            <a-->
<!--                routerLink="/settings"-->
<!--                routerLinkActive="active"-->
<!--                matTooltip="Насройки"-->
<!--                class="menu__link"-->
<!--            >-->
<!--                <div class="menu__icon" [style]="{-->
<!--                '&#45;&#45;bg-img': 'url(/assets/icons/default/settings-black.svg)',-->
<!--                '&#45;&#45;bg-img-active': 'url(/assets/icons/active/settings-white.svg)',-->
<!--                }"></div>-->
<!--                <span class="menu__name">Настройки</span>-->
<!--            </a>-->
            <div
                matTooltip="Выйти"
                class="menu__link"
                (click)="exit()"
                [style.cursor]="'pointer'"
            >
                <div class="menu__icon" [style]="{'--bg-img': 'url(/assets/icons/default/logout-black.svg)'}"></div>
                <span class="menu__name">Выйти</span>
            </div>
        </div>
    </div>

    <div class="list-block reduced" [class.active]="reduced">
        <div class="header-block">
            <app-user-badge [state]="'regular'"/>
            <a
                routerLink="/"
                [routerLinkActiveOptions]="{exact: true}"
                routerLinkActive="active"
                matTooltip="Главная"
                class="menu__link reduced"
            >
                <div class="menu__icon" [style]="{
            '--bg-img': 'url(/assets/icons/default/home-black.svg)',
            '--bg-img-active': 'url(/assets/icons/active/home-white.svg)',
            }"></div>
            </a>
            <div class="details">
                @for (item of menu.test; track item.name) {
                    @if (guardMenu(item.right)|async) {
                        <a
                            [routerLink]="item.href"
                            routerLinkActive="active"
                            class="menu__link reduced"
                            [matTooltip]="item.name"
                        >
                            <div class="menu__icon" [style]="{
                    '--bg-img': 'url('+item.icon+')',
                    '--bg-img-active': 'url('+item.active+')',
                    }"></div>
                        </a>
                    }
                }
            </div>
            <div class="details">
                @for (item of menu.guides; track item.name) {
                    @if (guardMenu(item.right)|async) {
                        <a
                            [routerLink]="item.href"
                            routerLinkActive="active"
                            [matTooltip]="item.name"

                            class="menu__link reduced"
                        >
                            <div class="menu__icon" [style]="{
                    '--bg-img': 'url('+item.icon+')',
                    '--bg-img-active': 'url('+item.active+')',
                    }"></div>
                        </a>
                    }
                }
            </div>
            <div class="details">
                @for (item of menu.analytics; track item.name) {
                    @if (guardMenu(item.right)|async) {
                        <a
                            [routerLink]="item.href"
                            routerLinkActive="active"
                            [matTooltip]="item.name"

                            class="menu__link reduced"
                        >
                            <div class="menu__icon" [style]="{
                    '--bg-img': 'url('+item.icon+')',
                    '--bg-img-active': 'url('+item.active+')',
                    }"></div>
                        </a>
                    }
                }
            </div>
            <div class="details">
                @for (item of menu.admin; track item.name) {
                    @if (guardMenu(item.right)|async) {
                        <a
                            [routerLink]="item.href"
                            routerLinkActive="active"
                            [matTooltip]="item.name"

                            class="menu__link reduced"
                        >
                            <div class="menu__icon" [style]="{
                    '--bg-img': 'url('+item.icon+')',
                    '--bg-img-active': 'url('+item.active+')',
                    }"></div>
                        </a>
                    }
                }
            </div>
        </div>
        <div class="footer-block">
            <div class="details">
<!--                <a-->
<!--                    routerLink="/settings"-->
<!--                    routerLinkActive="active"-->
<!--                    matTooltip="Настройки"-->
<!--                    class="menu__link reduced"-->
<!--                >-->
<!--                    <div class="menu__icon" [style]="{-->
<!--                '&#45;&#45;bg-img': 'url(/assets/icons/default/settings-black.svg)',-->
<!--                '&#45;&#45;bg-img-active': 'url(/assets/icons/active/settings-white.svg)',-->
<!--                }"></div>-->
<!--                </a>-->
                <div
                    matTooltip="Выйти"
                    class="menu__link reduced"
                    (click)="exit()"
                    [style.cursor]="'pointer'"
                >
                    <div class="menu__icon" [style]="{'--bg-img': 'url(/assets/icons/default/logout-black.svg)'}"></div>
                </div>
            </div>
        </div>
    </div>
</div>
